/* eslint-disable jsx-a11y/anchor-is-valid */
import { Box, Button, Table, Text, useMantineTheme } from "@mantine/core";
import { useState } from "react";
import CustomModal from "../../../../Components/CustomModals/Modal/Modal";
import { useTranslation } from "react-i18next";
import { useStyles } from "./styles";

type IUser = {
  id: string;
  companyName: string;
  responsible: string;
  email: string;
  phone: string;
  request: number;
};

const UsersPendientListTable = ({
  elements,
  activateOrDesactivateUser,
}: {
  elements: IUser[];
  activateOrDesactivateUser: (id: string, activate: boolean) => void;
}) => {
  const [userDeletedVisible, setUserDeletedVisible] = useState({
    isVisible: false,
    success: false,
  });
  const { classes } = useStyles();
  const { t } = useTranslation();
  const theme = useMantineTheme();

  return (
    <>
      <Table highlightOnHover className={classes.table}>
        <thead className={classes.tableHeader}>
          <tr>
            <th>
              <Text className={classes.headText}>{t("nameAndLastName")}</Text>
            </th>
            <th>
              <Text className={classes.headText}>{t("position")}</Text>
            </th>
            <th>
              <Text className={classes.headText}>{t("emailLabel")}</Text>
            </th>
            <th style={{ textAlign: "center" }}>
              <Text className={classes.headText}>Rol</Text>
            </th>
            <th style={{ textAlign: "center" }}>
              <Text className={classes.headText}>{t("actionsLabel")}</Text>
            </th>
          </tr>
        </thead>
        {elements.length > 0 ? (
          <tbody className={classes.bodyContainer}>
            {elements.map((element: any) => (
              <tr key={element.id}>
                <td>
                  <Text className={classes.tableText}>
                    {element?.firstName || "-"} {element?.lastName}
                  </Text>
                </td>
                <td>
                  <Text className={classes.tableText}>
                    {element?.position || "-"}
                  </Text>
                </td>
                <td>
                  <Text className={classes.tableText}>
                    {element?.email || "-"}
                  </Text>
                </td>
                <td>
                  <Text
                    className={classes.roles}
                    style={{
                      backgroundColor:
                        element?.role.toString() === "admin"
                          ? theme.colors.green[4]
                          : element?.role.toString() === "superadmin"
                          ? theme.colors.yellow[4]
                          : theme.colors.red[4],
                    }}
                  >
                    {element?.role === "authorized_user"
                      ? t("authorizedUser")
                      : element?.role}
                  </Text>
                </td>
                <td>
                  <Box className={classes.actionsContainer}>
                    <Button
                      variant="subtle"
                      className={classes.actionLink}
                      style={{
                        backgroundColor: theme.colors.dark[2],
                        color: theme.colors.dark[1],
                      }}
                      onClick={() =>
                        activateOrDesactivateUser(element.id, true)
                      }
                    >
                      {t("approve")}
                    </Button>
                    <Button
                      variant="subtle"
                      className={classes.actionLink}
                      style={{
                        border: `1px solid red`,
                        color: "red",
                        marginLeft: "1rem",
                      }}
                      onClick={() =>
                        activateOrDesactivateUser(element.id, false)
                      }
                    >
                      {t("decline")}
                    </Button>
                  </Box>
                </td>
              </tr>
            ))}
          </tbody>
        ) : (
          <tbody className={classes.bodyContainer}>
            <tr>
              <td>
                <Text className={classes.emptyResultsMessage}>
                  {t("emptyResults")}
                </Text>
              </td>
            </tr>
          </tbody>
        )}
      </Table>
      {userDeletedVisible.isVisible && (
        <CustomModal
          isModalVisible={userDeletedVisible.isVisible}
          onCloseModal={() =>
            setUserDeletedVisible({
              isVisible: false,
              success: false,
            })
          }
          success={userDeletedVisible.success}
          title={"clientDeletedMessage"}
        />
      )}
    </>
  );
};

export default UsersPendientListTable;
